import Link from '@mui/material/Link';
import { t } from 'i18next';
import React from 'react';

import { ROUTES as routes } from '~router/routePaths';

const LinkToSignIn = () => {
  return (
    <Link
      href={routes.signIn}
      variant="body2"
      sx={{
        color: 'secondary.main',
      }}
    >
      {t('actions.signIn')}
    </Link>
  );
};
export default LinkToSignIn;
